<template>
  <div class="section" :style="`background-color:${backgroundColor}`">
    <p
      v-t="'Newsletter.news_and_notifications'"
      class="title is-4 is-size-5-mobile has-text-centered has-text-green-blue"
    />
    <div id="mc_embed_signup">
      <form
        id="mc-embedded-subscribe-form"
        action="https://mobileworldcapital.us12.list-manage.com/subscribe/post?u=4fad4c034c9630d4d05c80a99&amp;id=e6934f6547"
        method="post"
        name="mc-embedded-subscribe-form"
        class="validate"
        target="_blank"
        novalidate
      >
        <div class="columns is-centered">
          <div class="column is-half">
            <h6 v-t="'Newsletter.hint-text'" class="is-size-6 has-text-left"/>
            <div class="field has-addons" style="margin-left:0">
              <div class="control content is-expanded clear">
                <input
                  class="input is-large has-background-white"
                  type="email"
                  name="EMAIL"
                  placeholder="Email"
                >
              </div>
              <div class="control">
                <a class="button is-large is-secondary">
                  <input
                    id="mc-embedded-subscribe"
                    :value="$t('App.send')"
                    type="submit"
                    class="button is-large is-secondary is-size-6 has-text-weight-bold is-uppercase"
                    @click="$ga.event('signup', 'click', 'newsletter')"
                  >
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="mc-field-group input-group" style="display:none">
          <strong>Sign up</strong>
          <ul>
            <li>
              <input
                id="mce-group[16813]-16813-0"
                type="checkbox"
                value="8796093022208"
                name="group[16813][8796093022208]"
                checked
              >
              <label for="mce-group[16813]-16813-0">SDG Challenge</label>
            </li>
            <li>
              <input
                id="mce-group[16813]-16813-1"
                type="checkbox"
                value="17592186044416"
                name="group[16813][17592186044416]"
              >
              <label for="mce-group[16813]-16813-1">Main webpage</label>
            </li>
            <li>
              <input
                id="mce-group[16813]-16813-2"
                type="checkbox"
                value="35184372088832"
                name="group[16813][35184372088832]"
              >
              <label for="mce-group[16813]-16813-2">MHM</label>
            </li>
            <li>
              <input
                id="mce-group[16813]-16813-3"
                type="checkbox"
                value="70368744177664"
                name="group[16813][70368744177664]"
              >
              <label for="mce-group[16813]-16813-3">Toolbox</label>
            </li>
          </ul>
        </div>
        <div id="mce-responses" class="clear">
          <div id="mce-error-response" class="response" style="display:none"/>
          <div id="mce-success-response" class="response" style="display:none"/>
        </div>
        <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
        <div style="position: absolute; left: -5000px;" aria-hidden="true">
          <input type="text" name="b_4fad4c034c9630d4d05c80a99_e6934f6547" tabindex="-1" value>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-newsletter',
  props: {
    backgroundColor: {
      type: String,
      default: '#bad2e8'
    }
  }
}
</script>

<style scoped>
</style>
